(() => {
  if (window.vvCampaignTrackingMounted) return;
  window.vvCampaignTrackingMounted = true;
  window.dataLayer = window.dataLayer || [];

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-vv-campaign]');
    if (!link) return;

    const detail = {
      event: 'select_promotion',
      ecommerce: {
        promotion_id: link.dataset.vvCampaign,
        promotion_name: link.dataset.vvCampaignName || link.textContent.trim(),
        creative_name: 'home_hero',
        creative_slot: 'hero_primary',
      },
    };

    window.dataLayer.push(detail);
    document.dispatchEvent(new CustomEvent('vv:campaign-click', { detail }));
  });
})();
